import { Skeleton } from '@/components/ui/skeleton';
import { FC, useEffect, useRef } from 'react';

type Props = {
	data1?: number;
	data2?: number;
	showFooter?: boolean;
};

const DashboardManagedByChartSkeleton: FC<Props> = ({
	data1 = 75,
	data2 = 25,
	showFooter = true,
}) => {
	const canvasRef = useRef<HTMLCanvasElement>(null);

	const totalValue = data1 + data2;

	useEffect(() => {
		const canvas = canvasRef.current;
		if (!canvas) return;
		const ctx = canvas.getContext('2d');
		if (!ctx) return;

		const width = canvas.width;
		const height = canvas.height;
		const centerX = width / 2;
		const centerY = height / 2;
		const radius = Math.min(width, height) / 2 - 10;
		const lineWidth = 15;
		const gapAngle = 0.2;

		ctx.clearRect(0, 0, width, height);
		ctx.lineWidth = lineWidth;
		ctx.lineCap = 'round';

		let startAngle = -Math.PI / 2;

		const data = [data2, data1];

		data.forEach((segment) => {
			const angle =
				(segment / totalValue) *
				(2 * Math.PI - gapAngle * data.length);
			ctx.beginPath();
			ctx.strokeStyle = '#eaeaea';
			ctx.arc(centerX, centerY, radius, startAngle, startAngle + angle);
			ctx.stroke();
			startAngle += angle + gapAngle;
		});
	}, [data1, data2]);

	return (
		<div className='flex flex-col gap-4'>
			<div className='relative w-60 h-60'>
				<canvas
					ref={canvasRef}
					width={240}
					height={240}
					className='w-full h-full animate-pulse'
				/>
				<div className='absolute inset-0 flex flex-col justify-center items-center'>
					<Skeleton className='h-3 w-40 my-1 rounded-full' />
					<Skeleton className='h-3 w-16 my-1 rounded-full' />
				</div>
			</div>
			{showFooter && (
				<div className='flex justify-center items-center gap-4'>
					<div className='flex items-center gap-1'>
						<Skeleton className='h-3 w-3 my-1 rounded-full' />
						<Skeleton className='h-3 w-8 my-1 rounded-full' />
					</div>
					<div className='flex items-center gap-1'>
						<Skeleton className='h-3 w-3 my-1 rounded-full' />
						<Skeleton className='h-3 w-12 my-1 rounded-full' />
					</div>
				</div>
			)}
		</div>
	);
};

export default DashboardManagedByChartSkeleton;
